import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import type { PhoneVerificationConfig } from '@fiverr-private/code_activation_triggers';

const T_PREFIX = 'seller_pages_toolbox.activation.phone';

export const startMessagingVerificationConfig: PhoneVerificationConfig = {
    title: (
        <Container textAlign="center" maxWidth="500px">
            <I18n k={`${T_PREFIX}.start_messaging.title`} />
        </Container>
    ),
    subtitle: (
        <Text size="b_sm" textAlign="center" maxWidth="450px">
            <I18n k={`${T_PREFIX}.start_messaging.subtitle`} />
        </Text>
    ),
};
